import React, { useCallback, useEffect, useState } from 'react';
import { LobbyWidget, Timer, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { BottomSheet } from '@bonanza-social/navigation';
import useDailyGift from '../../hooks/useDailyGift';
import { trackEvent, useDispatch } from '@bonanza-social/toolkit/state';
import { fetchDailyRewards } from '@bonanza-social/daily-rewards/state';
import { useDailyRewardCoinAnimation } from '@bonanza-social/daily-rewards';
import { View } from 'react-native';

function DailyGiftWidget() {
  const dispatch = useDispatch();

  const [t, i18n] = useTranslation('dailyGift');
  const { dailyGift, dailyGiftStatus } = useDailyGift();
  const { widgetRef } = useDailyRewardCoinAnimation('DailyGift');

  const handleClick = () => {
    if (dailyGiftStatus === 'Pending') {
      dispatch(
        trackEvent({
          name: 'daily_gift_clicked',
          params: {
            status: dailyGiftStatus,
          },
        }),
      );
    }

    BottomSheet.open({
      namespace: 'dailyGift',
      type: 'default',
      light: true,
    });
  };

  const [timeEnded, setTimeEnded] = useState(true);
  const [timerLabel, setTimerLabel] = useState<string | null>(null);

  const onTimeEnded = useCallback(() => {
    setTimeEnded(true);
    setTimerLabel(t('pendingCta'));
    dispatch(fetchDailyRewards());
  }, [dispatch, t]);

  useEffect(() => {
    switch (dailyGiftStatus) {
      case 'Awarded':
        setTimerLabel(t('claimIn'));
        setTimeEnded(false);
        break;
      case 'Pending':
        setTimerLabel(t('pendingCta'));
        setTimeEnded(true);
        break;
    }
  }, [dailyGiftStatus, t]);

  const timerComponent = (
    <>
      <Text variant="caption-semi" color="darkSurfacePrimary">
        {timerLabel}
      </Text>
      {!timeEnded && dailyGift?.nextAvailableAt && (
        <Timer
          color="darkSurfacePrimary"
          variant="caption-semi"
          time={dailyGift.nextAvailableAt}
          onCountDownComplete={onTimeEnded}
          displayMode="condensed"
        />
      )}
    </>
  );

  return dailyGift ? (
    <View ref={widgetRef}>
      <LobbyWidget
        image="common.BonanzaCoinStack"
        label={t('widgetLabel')}
        onClick={handleClick}
        badgeImageName={i18n.language !== 'fr' ? 'common.Clock' : undefined}
        badgeChildren={timerComponent}
        badgeBoxProps={{
          variant: 'gradient',
          gradient: 'warningBackground',
        }}
        hasUnread={timeEnded}
      />
    </View>
  ) : null;
}

export default memo(DailyGiftWidget);
